import { render, staticRenderFns } from "./FoliosReportDetail.vue?vue&type=template&id=adab9cea"
import script from "./FoliosReportDetail.vue?vue&type=script&lang=js"
export * from "./FoliosReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports